export default __webpack_public_path__ + "static/awards-mb-cl-1838f7c416605efaf2fcb04e3e69f0f6.png";